import { Outlet } from "react-router-dom";
import Header from "./header";
import Sidebar from "./sidebar";
import { useEffect, useState } from "react";

export default function MainLayout() {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [permissionsLoaded, setPermissionsLoaded] = useState(!!localStorage.getItem("userPermissions"));

    useEffect(() => {
        const handlePermissionsLoaded = () => {
            setPermissionsLoaded(true);
        };

        window.addEventListener(
            "userPermissionsLoaded",
            handlePermissionsLoaded
        );

        return () => {
            window.removeEventListener(
                "userPermissionsLoaded",
                handlePermissionsLoaded
            );
        };
    }, []);

    return (
        <>
            <Header onToggle={() => setIsCollapsed(prev => !prev)} />
            <div className="h-[calc(100vh-4rem)] w-full flex">
                {permissionsLoaded && (
                    <Sidebar isCollapsed={isCollapsed} />
                )}

                <main className={`w-full ${isCollapsed ? 'lg:w-[calc(100%-5rem)]' : 'lg:w-[calc(100%-18rem)]'}  `}>
                    <Outlet />
                </main>
            </div>
        </>
    );
}
